export default {
  props: {
    model: {
      type: Object,
      default() {
        return {
          type: '',
          title: ''
          // ...
          // 等其他业务key
        };
      }
    }
  },
  data() {
    return {
      visible: true
    };
  }
};
